import { takeLatest, all } from "redux-saga/effects"

import { StartupTypes } from "../redux/startup.redux"
import * as StartupSagas from "./startup.sagas"

import { WizardTypes } from "../redux/wizard.redux"
import * as WizardSagas from "./wizard.sagas"

import * as AnalyticsSagas from "./analytics.sagas"

export default function* root() {
  yield all([
    takeLatest(StartupTypes.STARTUP, StartupSagas.startup),
    takeLatest(WizardTypes.SUBMIT_NEW, WizardSagas.onSubmitNew),
    takeLatest(WizardTypes.SUBMIT_RENEWAL, WizardSagas.onSubmitRenewal),
    takeLatest(
      WizardTypes.ANALYTICS_QUESTION_VIEWED,
      AnalyticsSagas.onQuestionViewed
    ),
    takeLatest(
      WizardTypes.ANALYTICS_QUESTION_ANSWERED,
      AnalyticsSagas.onQuestionAnswered
    ),
    takeLatest(AnalyticsSagas.AnalyticTypes.IDENTIFY, AnalyticsSagas.onIdentify)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js